import { atom } from "recoil";

export const WordsLengthAtom = atom({
  key: "WordsLengthAtom",
  default: 0,
});
